module.exports = ".table-responsive {\n  height: 100%;\n  overflow: visible; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/limit-flow-proposal/component/limit-flow-proposal/culture/culture.component.scss
// module id = ./src/app/limit-flow-proposal/component/limit-flow-proposal/culture/culture.component.scss
// module chunks = main